import { IFile } from "../domain/models/File";
import { IDevelopmentHistoryFlat } from "../domain/models/DevelopmentHistory";
import { BaseModelImpl } from "./BaseModelImpl";

export class DevelopmentHistoryFlatModel extends BaseModelImpl<IDevelopmentHistoryFlat> implements IDevelopmentHistoryFlat {
    id: string;
    files?: IFile[];

    languageCode: string;

    title: string;
    description: string;
    stageDateTime: string;
    imageUrl?: string;

    creatorId: string;
    createdAt?: Date;
    updatedAt?: Date;

    constructor(data?: IDevelopmentHistoryFlat) {
        super();
        this.assignData(data);
    }
}
